export default {
  "Connect Wallet": '連結錢包',
  "Loading":"載入中...",
  "Purchase Quantity": "購買數量",
  "Total Amount": "總額",
  "Payment Method": "付款方式",
  "Fee": "手續費",
  "Purchase": "購買",
  "Select Payment Method": "選擇付款方式",
  "Language Switch": "語言切換",
  "Mall": "商城",
  "STAR Purchase": "STAR 購買",
  "Order Details": "訂單詳情",
  "My Orders": "我的訂單",
  "Order Confirmation Page": "訂單確認頁",
  "Product Details": "商品詳情",
  "Store Details": "店鋪詳情",
  "Staking MUSE":"質押MUSE",
  "My Stake":"我的質押",
  "Redeemable Time":"可贖回時間",
  "Redeem":"贖回",
  "Stake":"質押",
  "How to Obtain MUSE":"如何獲取MUSE",
  "Activity Rules":"活動規則",
  "Stake Amount":"質押數量",
  "Please Enter Amount":"請輸入數量",
  "Balance":"餘額",
  "Redeem Amount":"贖回數量",
  "Confirm":"確認",
  "Cancel":"取消",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"質押MUSE，可以增加StarNest平台活動的投票數量，給你喜歡的選手投票。",
  "Rule1":"1.透過質押MUSE，增加StarNest平台活動的投票權重(參考對應活動說明)。",
  "Rule2":"2. 質押的MUSE在所投活動結束後可隨時贖回。",
  "Rule3":"3. 質押MUSE，還可以參加平台治理與的其他活動。",
  "Rule4":"4. 最終解釋權歸StarNest平台。",
  "Staked":"已質押",
  "Redeemed":"已贖回",
  "Payment":"支付",
  "Next step":"下一步",
  "Amount":"金額",
  "Copied":"已複製",
  "QRCodeTip":"請掃描二維碼或複製地址支付訂單金額,如支付金額不足,則訂單失敗,且不退款.",
  "Scan QR code to pay":"掃描二維碼支付",
  "DownloadTip":"掃碼下載 StarNest App，立即體驗",
  "Save QR code":"儲存二維碼",
  "Minimum":"最低",
  "All":"全部",
  "Failed to create order":"建立訂單失敗",
  "The order was created successfully and payment is being redirected":"創建訂單成功，正在跳躍支付",
  "Payment details":"付款詳情",
  "Address management":"地址管理",
  "New address":"新建地址",
  "Delete address":"刪除地址",
  "Are you sure you want to delete this address?":"確定要刪除這個地址嗎",
  "First name":"姓氏",
  "Last name":"名字",
  "Please enter":"請輸入",
  "Phone":"手機號",
  "Country":"國家/地區",
  "State/Province":"州/省",
  "City":"城市",
  "Address":"詳細地址",
  "Zip code":"郵遞區號",
  "Email":"郵箱",
  "Save address":"儲存地址",
  "The address has been edited, do you want to save it?":"地址已編輯,是否要儲存?",
  "Return":"返回",
  "Save":"儲存",
  "Waiting for payment":"等待付款",
  "Please complete the payment within time as soon as possible":"請在{time}內儘快完成付款",
  "Expired":"已過期",
  "Order ID":"訂單ID",
  "Order total":"訂單總額",
  "Order time":"訂單時間",
  "Payment method":"支付方式",
  "Billing address":"帳單地址",
  "Switch address":"切換地址",
  "Pay":"確認支付",
  "Deleted":"已刪除",
  "Please fill in the form completely":"請完整填寫表單",
  "Create success":"創建成功",
  "Update success":"修改成功",
  "Insufficient balance":"餘額不足",
  "No address filled in yet":"尚未填寫地址",
  "Choose country":"選擇國家",
  "Please enter search keywords":"請輸入搜索關鍵詞",
  "Payment successful":"支付成功",
  "Please check the balance in your wallet":"請在錢包查看餘額",
  "Finish":"完成",
  "Payment failed":"支付失敗",
  "Please complete the payment in time in My Order-Waiting for Payment":"請在我的訂單-待支付中及時完成支付",
  "Uploading":"上傳中",
  "Upload payment voucher":"上傳支付憑證",
  "Submission successful, please check the order later":"提交成功，請稍後查看訂單",
  "Confirm submission":"確認提交",
  "Detail":"詳情",
  "Rate tip":"根據支付方式不同，票價可能存在匯率差異，以最終支付金額為準。",
  "Please log in":"請前往登錄",
  "Insufficient product inventory":"商品庫存不足",
  "Showtime":"場次",
  "Ticket file":"票檔",
  "Sold out":"售罄",
  "Limit tickets per order":"每筆訂單限購 {num} 張",
  "Please select region":"請選擇地區",
  "Please fill in the correct email address":"請填寫準確的email地址",
  "Delivery method":"配送方式",
  "E-ticket":"電子票",
  "Direct entry":"直接入場",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"支付成功後，無需取票，前往票夾查看入場憑證",
  "Contact person":"聯繫人",
  "Name":"姓名",
  "Please fill in the contact name":"請填寫聯繫人姓名",
  "Region":"地區",
  "Please enter the mobile number":"請輸入手機號碼",
  "Please fill in the email":"請填寫郵箱",
  "The ticket verification code will be sent to your email via":"門票核銷碼將會通過電子郵件發送到您的郵箱中",
  "Details":"明細",
  "Submit order":"提交訂單",
  "Price details":"價格明細",
  "The actual discount amount is subject to the following single page":"實際優惠金額以下單頁為準",
  "Product information":"商品信息",
  "STAR deduction":"STAR抵扣",
  "Credit Card":"信用卡",
  "Payment Platform":"支付平台",
  "On-Chain Payment":"鏈上支付",
  "Other":"其他",
  "No refunds":"不支持退款",
  "Transferable":"可转赠",
  "Not transferable":"不可转赠",
  "Ended":"已結束",
  "Countdown":"倒數計時",
  "Please select the ticket file":"請選擇票檔",
  "Insufficient commodity inventory":"商品库存不足",
  "Integral Mall":"積分商城",
 "All Products":"全部商品",
 "Integral Records":"積分記錄",
 "Transaction Details":"交易詳情",
  "what": "什麼是MUSE？",
  "museIntro": "MUSE是基於Armonia Meta Chain的ARC20代幣，總量21億，80%通過生態挖礦產出。",
  "museUse": "MUSE有什麼用？",
  "copyrightStaking": "版權質押",
  "copyrightStaking1": "質押MUSE至藝人版權NFT（元宇宙AI、肖像等），共享版權收益。",
  "vote": "大賽投票",
  "vote1": "質押MUSE可獲STAR NEST WAR額外投票權。",
  "product": "產品購買",
  "product1": "購買限量NFT、周邊、門票（早鳥/VIP）。",
  "more": "更多功能（持續更新）",
  "more1": "鏈遊生態：授權遊戲使用藝人IP，MUSE支付。",
  "more2": "支持藝人：用MUSE打賞創作者。",
  "activity": "特邀活動",
  "activity1": "獲取特定活動邀請資格。",
  "how": "如何獲取MUSE？",
  "how1": "參與早期私募。",
  "how2": "創作作品獲得獎勵。",
  "how3": "參與活動（購票、消費）獲空投。",
  "how4": "收聽/觀看部分部分 Audition 作品，邊聽邊賺",
  "Redeem now":"立即兌換",
  "Basic information":"基本訊息",
}